import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import Link from "./Link";
var Content = styled.div.withConfig({
  displayName: "ActionCard__Content",
  componentId: "gy4g5e-0"
})(["padding:1.5rem;"]);
var Description = styled.p.withConfig({
  displayName: "ActionCard__Description",
  componentId: "gy4g5e-1"
})(["opacity:0.8;"]);
var ImageWrapper = styled.div.withConfig({
  displayName: "ActionCard__ImageWrapper",
  componentId: "gy4g5e-2"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;background:", ";box-shadow:inset 0px -1px 0px rgba(0,0,0,0.1);min-height:260px;"], function (props) {
  return props.theme.colors.cardGradient;
});
var Image = styled(Img).withConfig({
  displayName: "ActionCard__Image",
  componentId: "gy4g5e-3"
})(["width:100%;width:100%;min-width:100px;min-height:100px;max-width:372px;max-height:257px;@media (max-width:", "){max-width:311px;}"], function (props) {
  return props.theme.breakpoints.s;
});
var Card = styled(Link).withConfig({
  displayName: "ActionCard__Card",
  componentId: "gy4g5e-4"
})(["text-decoration:none;flex:1 1 372px;color:", ";box-shadow:0px 14px 66px rgba(0,0,0,0.07),0px 10px 17px rgba(0,0,0,0.03),0px 4px 7px rgba(0,0,0,0.05);margin:1rem;&:hover{border-radius:4px;box-shadow:0px 8px 17px rgba(0,0,0,0.15);background:", ";transition:transform 0.1s;transform:scale(1.02);}"], function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.tableBackgroundHover;
});

var ActionCard = function ActionCard(_ref) {
  var to = _ref.to,
      alt = _ref.alt,
      image = _ref.image,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className;
  var isImageURL = typeof image === "string" && image.includes("http");
  return /*#__PURE__*/React.createElement(Card, {
    to: to,
    className: className,
    hideArrow: true
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    className: "action-card-image-wrapper"
  }, !isImageURL && /*#__PURE__*/React.createElement(Image, {
    fixed: image,
    alt: alt
  }), isImageURL && /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: alt,
    className: "action-card-image"
  })), /*#__PURE__*/React.createElement(Content, {
    className: "action-card-content"
  }, /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement(Description, null, description), children));
};

export default ActionCard;